// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/visit2 */
export async function visit2ControllerUpdate(
	body: API.Visit2UpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/visit2', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/visit2/${param0} */
export async function visit2ControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit2ControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.Visit2ViewResponse>(`/api/visit2/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/visit2/${param0} */
export async function visit2ControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit2ControllerCreateParams,
	body: API.Visit2CreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/visit2/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}
